import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonthYearPipe, PotentialRevenueComponent } from './potential-revenue.component';
import { TranslateModule } from '@ngx-translate/core';
import { PreferredCurrencyModule } from '@vendasta/sales-common';
import { RevenueDateDropdownModule } from './revenue-date-dropdown/revenue-date-dropdown.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PotentialRevenueService } from './potential-revenue.service';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  providers: [PotentialRevenueService],
  declarations: [PotentialRevenueComponent, MonthYearPipe],
  imports: [
    CommonModule,
    TranslateModule,
    PreferredCurrencyModule,
    RevenueDateDropdownModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  exports: [PotentialRevenueComponent],
})
export class PotentialRevenueModule {}
